export const homeStyle = {
    computer: {
        bio: {
            container: {
                marginBottom: "3%"
            },
            font: {
                fontSize: "24px",
                fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                color: "white"
            }
        },
        social: {
            container: {
                marginTop: "15%",
                marginLeft: "25%"
            },
            text: {
                fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                color: "white"
            },
            icon: {
                color: "white"
            }
        },
        contact: {
            header: {
                marginTop: "20%",
                marginLeft: "24%",
                fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                color: "white"
            },
            phone: {
                marginLeft: "2.5%",
                fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                color: "white"
            },
            email: {
                marginLeft: "2.5%",
                marginBottom: "30%",
                fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                color: "white"
            }
        }
    },
    tablet: {
        bio: {
            container: {
                marginBottom: "3%"
            },
            font: {
                fontSize: "24px",
                fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                color: "white"
            }
        },
        social: {
            container: {
                marginTop: "5%"
            },
            text: {
                fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                color: "white"
            },
            icon: {
                color: "white"
            }
        },
        contact: {
            header: {
                marginTop: "5%",
                fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                color: "white"
            },
            phone: {
                marginLeft: "-13%",
                fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                color: "white"
            },
            email: {
                marginLeft: "-13%",
                fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                color: "white"
            }
        }
    },
    mobile: {
        bio: {
            container: {
                marginBottom: "3%"
            },
            font: {
                fontSize: "24px",
                fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                color: "white"
            }
        },
        social: {
            container: {
                marginTop: "10%",
                marginBottom: "5%"
            },
            text: {
                fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                color: "white"
            },
            icon: {
                color: "white"
            }
        },
        contact: {
            header: {
                marginTop: "10%",
                marginLeft: "14%",
                fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                color: "white"
            },
            phone: {
                fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                color: "white"
            },
            email: {
                fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                color: "white"
            }
        }
    }

};